module.exports = __webpack_public_path__ + "img/Jetson-nano.013a48b4.png";